/**
 * --------------------------------------------------
 * !!! THIS FILE WAS GENERATED BY GRAPHQL-CODEGEN !!!
 * !!!   DO NOT MODIFY THIS FILE BY YOURSELF      !!!
 * --------------------------------------------------
 */

import * as c from "@hex/common";
import type * as Types from "../../../generated/graphqlTypes";

import { gql } from "@apollo/client";
import {
  DatabaseSearchResultsForSqlCompletionFragmentDoc,
  SchemaSearchResultsForSqlCompletionFragmentDoc,
  TableSearchResultsForSqlCompletionFragmentDoc,
  ColumnSearchResultsForSqlCompletionFragmentDoc,
} from "./sqlCompletionItems.generated";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type GetDataConnectionDetailsForSqlCompletionProviderQueryVariables =
  Types.Exact<{
    dataConnectionId: Types.Scalars["DataConnectionId"]["input"];
  }>;

export type GetDataConnectionDetailsForSqlCompletionProviderQuery = {
  readonly __typename: "Query";
  readonly dataConnectionById: {
    readonly __typename: "DataConnection";
    readonly id: c.DataConnectionId;
    readonly isMultiDatabase: boolean;
    readonly connectionType: c.DataConnectionType;
    readonly defaultDatabase: {
      readonly __typename: "DataSourceDatabase";
      readonly id: c.DataSourceDatabaseId;
      readonly name: string | null;
    } | null;
  };
};

export type SearchSchemaForSqlCompletionProviderQueryVariables = Types.Exact<{
  dataConnectionId:
    | ReadonlyArray<Types.Scalars["DataConnectionId"]["input"]>
    | Types.Scalars["DataConnectionId"]["input"];
  query: Types.Scalars["String"]["input"];
  resultTypes:
    | ReadonlyArray<Types.SchemaElementSearchResultType>
    | Types.SchemaElementSearchResultType;
  schemaFilters: Types.InputMaybe<
    | ReadonlyArray<Types.SchemaElementSearchSchemaFilter>
    | Types.SchemaElementSearchSchemaFilter
  >;
  tableFilters: Types.InputMaybe<
    | ReadonlyArray<Types.SchemaElementSearchTableFilter>
    | Types.SchemaElementSearchTableFilter
  >;
  columnFilters: Types.InputMaybe<
    | ReadonlyArray<Types.SchemaElementSearchColumnFilter>
    | Types.SchemaElementSearchColumnFilter
  >;
}>;

export type SearchSchemaForSqlCompletionProviderQuery = {
  readonly __typename: "Query";
  readonly searchSchemaElements: {
    readonly __typename: "SchemaElementSearchResults";
    readonly databases: {
      readonly __typename: "DatabaseSearchResults";
      readonly databaseResultCount: number;
      readonly databaseSearchResults: ReadonlyArray<{
        readonly __typename: "DataSourceDatabase";
        readonly name: string | null;
      }>;
    };
    readonly schemas: {
      readonly __typename: "SchemaSearchResults";
      readonly schemaResultCount: number;
      readonly schemaSearchResults: ReadonlyArray<{
        readonly __typename: "DataSourceSchema";
        readonly name: string;
        readonly dataSourceDatabase: {
          readonly __typename: "DataSourceDatabase";
          readonly name: string | null;
        };
      }>;
    };
    readonly tables: {
      readonly __typename: "TableSearchResults";
      readonly tableResultCount: number;
      readonly tableSearchResults: ReadonlyArray<{
        readonly __typename: "DataSourceTable";
        readonly name: string;
        readonly dataSourceSchema: {
          readonly __typename: "DataSourceSchema";
          readonly name: string;
          readonly dataSourceDatabase: {
            readonly __typename: "DataSourceDatabase";
            readonly name: string | null;
          };
        };
      }>;
    };
    readonly columns: {
      readonly __typename: "ColumnSearchResults";
      readonly columnResultCount: number;
      readonly columnSearchResults: ReadonlyArray<{
        readonly __typename: "DataSourceColumn";
        readonly name: string;
        readonly type: string;
        readonly dataSourceTable: {
          readonly __typename: "DataSourceTable";
          readonly name: string;
          readonly dataSourceSchema: {
            readonly __typename: "DataSourceSchema";
            readonly name: string;
          };
        };
      }>;
    };
  };
};

export const GetDataConnectionDetailsForSqlCompletionProviderDocument = /*#__PURE__*/ gql`
  query GetDataConnectionDetailsForSqlCompletionProvider(
    $dataConnectionId: DataConnectionId!
  ) {
    dataConnectionById(dataConnectionId: $dataConnectionId) {
      id
      defaultDatabase {
        id
        name
      }
      isMultiDatabase
      connectionType
    }
  }
`;

/**
 * __useGetDataConnectionDetailsForSqlCompletionProviderQuery__
 *
 * To run a query within a React component, call `useGetDataConnectionDetailsForSqlCompletionProviderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDataConnectionDetailsForSqlCompletionProviderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDataConnectionDetailsForSqlCompletionProviderQuery({
 *   variables: {
 *      dataConnectionId: // value for 'dataConnectionId'
 *   },
 * });
 */
export function useGetDataConnectionDetailsForSqlCompletionProviderQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetDataConnectionDetailsForSqlCompletionProviderQuery,
    GetDataConnectionDetailsForSqlCompletionProviderQueryVariables
  > &
    (
      | {
          variables: GetDataConnectionDetailsForSqlCompletionProviderQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetDataConnectionDetailsForSqlCompletionProviderQuery,
    GetDataConnectionDetailsForSqlCompletionProviderQueryVariables
  >(GetDataConnectionDetailsForSqlCompletionProviderDocument, options);
}
export function useGetDataConnectionDetailsForSqlCompletionProviderLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetDataConnectionDetailsForSqlCompletionProviderQuery,
    GetDataConnectionDetailsForSqlCompletionProviderQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetDataConnectionDetailsForSqlCompletionProviderQuery,
    GetDataConnectionDetailsForSqlCompletionProviderQueryVariables
  >(GetDataConnectionDetailsForSqlCompletionProviderDocument, options);
}
export function useGetDataConnectionDetailsForSqlCompletionProviderSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetDataConnectionDetailsForSqlCompletionProviderQuery,
    GetDataConnectionDetailsForSqlCompletionProviderQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetDataConnectionDetailsForSqlCompletionProviderQuery,
    GetDataConnectionDetailsForSqlCompletionProviderQueryVariables
  >(GetDataConnectionDetailsForSqlCompletionProviderDocument, options);
}
export type GetDataConnectionDetailsForSqlCompletionProviderQueryHookResult =
  ReturnType<typeof useGetDataConnectionDetailsForSqlCompletionProviderQuery>;
export type GetDataConnectionDetailsForSqlCompletionProviderLazyQueryHookResult =
  ReturnType<
    typeof useGetDataConnectionDetailsForSqlCompletionProviderLazyQuery
  >;
export type GetDataConnectionDetailsForSqlCompletionProviderSuspenseQueryHookResult =
  ReturnType<
    typeof useGetDataConnectionDetailsForSqlCompletionProviderSuspenseQuery
  >;
export type GetDataConnectionDetailsForSqlCompletionProviderQueryResult =
  Apollo.QueryResult<
    GetDataConnectionDetailsForSqlCompletionProviderQuery,
    GetDataConnectionDetailsForSqlCompletionProviderQueryVariables
  >;
export const SearchSchemaForSqlCompletionProviderDocument = /*#__PURE__*/ gql`
  query SearchSchemaForSqlCompletionProvider(
    $dataConnectionId: [DataConnectionId!]!
    $query: String!
    $resultTypes: [SchemaElementSearchResultType!]!
    $schemaFilters: [SchemaElementSearchSchemaFilter!]
    $tableFilters: [SchemaElementSearchTableFilter!]
    $columnFilters: [SchemaElementSearchColumnFilter!]
  ) {
    searchSchemaElements(
      dataConnectionId: $dataConnectionId
      searchQuery: $query
      resultTypes: $resultTypes
      schemaFilters: $schemaFilters
      tableFilters: $tableFilters
      columnFilters: $columnFilters
      algorithm: PREFIX
      ignoreMetadata: true
    ) {
      databases {
        ...DatabaseSearchResultsForSqlCompletion
      }
      schemas {
        ...SchemaSearchResultsForSqlCompletion
      }
      tables {
        ...TableSearchResultsForSqlCompletion
      }
      columns {
        ...ColumnSearchResultsForSqlCompletion
      }
    }
  }
  ${DatabaseSearchResultsForSqlCompletionFragmentDoc}
  ${SchemaSearchResultsForSqlCompletionFragmentDoc}
  ${TableSearchResultsForSqlCompletionFragmentDoc}
  ${ColumnSearchResultsForSqlCompletionFragmentDoc}
`;

/**
 * __useSearchSchemaForSqlCompletionProviderQuery__
 *
 * To run a query within a React component, call `useSearchSchemaForSqlCompletionProviderQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchSchemaForSqlCompletionProviderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchSchemaForSqlCompletionProviderQuery({
 *   variables: {
 *      dataConnectionId: // value for 'dataConnectionId'
 *      query: // value for 'query'
 *      resultTypes: // value for 'resultTypes'
 *      schemaFilters: // value for 'schemaFilters'
 *      tableFilters: // value for 'tableFilters'
 *      columnFilters: // value for 'columnFilters'
 *   },
 * });
 */
export function useSearchSchemaForSqlCompletionProviderQuery(
  baseOptions: Apollo.QueryHookOptions<
    SearchSchemaForSqlCompletionProviderQuery,
    SearchSchemaForSqlCompletionProviderQueryVariables
  > &
    (
      | {
          variables: SearchSchemaForSqlCompletionProviderQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    SearchSchemaForSqlCompletionProviderQuery,
    SearchSchemaForSqlCompletionProviderQueryVariables
  >(SearchSchemaForSqlCompletionProviderDocument, options);
}
export function useSearchSchemaForSqlCompletionProviderLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SearchSchemaForSqlCompletionProviderQuery,
    SearchSchemaForSqlCompletionProviderQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    SearchSchemaForSqlCompletionProviderQuery,
    SearchSchemaForSqlCompletionProviderQueryVariables
  >(SearchSchemaForSqlCompletionProviderDocument, options);
}
export function useSearchSchemaForSqlCompletionProviderSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    SearchSchemaForSqlCompletionProviderQuery,
    SearchSchemaForSqlCompletionProviderQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    SearchSchemaForSqlCompletionProviderQuery,
    SearchSchemaForSqlCompletionProviderQueryVariables
  >(SearchSchemaForSqlCompletionProviderDocument, options);
}
export type SearchSchemaForSqlCompletionProviderQueryHookResult = ReturnType<
  typeof useSearchSchemaForSqlCompletionProviderQuery
>;
export type SearchSchemaForSqlCompletionProviderLazyQueryHookResult =
  ReturnType<typeof useSearchSchemaForSqlCompletionProviderLazyQuery>;
export type SearchSchemaForSqlCompletionProviderSuspenseQueryHookResult =
  ReturnType<typeof useSearchSchemaForSqlCompletionProviderSuspenseQuery>;
export type SearchSchemaForSqlCompletionProviderQueryResult =
  Apollo.QueryResult<
    SearchSchemaForSqlCompletionProviderQuery,
    SearchSchemaForSqlCompletionProviderQueryVariables
  >;
